const e = "Konto", n = "Kontosaldo", t = "Kontobeskrivelse", a = "Konto-ID", r = "Tilføjelser", i = "Justeringer", o = "Beløb", l = "og", d = "Anvend", s = "Tilbage", u = "Saldokonto", c = "Id for saldokonto", g = "Reserveret", p = "Indsamlet", f = "Kategori", k = "Chargebacks", m = "Luk", b = "Kontakt support", y = "Kontakt support for at få hjælp.", v = "Kontakt support for at få hjælp, og del fejlkode %{requestId}", h = "Kopieret", T = "Kopiér", R = "Rettelser", A = "Valuta", P = "Dato", D = "Datointerval", F = "Beskrivelse", S = "Afvis", C = "Download", N = "Downloader", O = "E-mail", I = "Enhed blev ikke fundet", B = "Transaktion blev ikke fundet for den angivne kontoindehaver", w = "Gebyrer", V = "Fil", x = "Filterbjælke", L = "Fra", W = "Fuld", j = "Indsamlede midler", K = "Gå tilbage", M = "Bevilliget tilskud", U = "Tilbagebetaling af tilskud", q = "Skjul indhold", E = "ID", G = "Ufuldstændigt felt", H = "Igangværende", Y = "Indlæser", _ = "maks.", z = "min.", X = "Mobil", J = "Nettoudbetaling", Q = "Næste udbetalinger", Z = "Ingen data", $ = "Ingen negative tal er tilladt", ee = "Ingen udbetalinger er fundet", ne = "Ingen rapporter fundet", te = "Ingen transaktioner er fundet", ae = "Andet", re = "Pagineret navigation", ie = "Delvis", oe = "Betalings-id", le = "Betalingsmetode", de = "Oplysninger om udbetaling", se = "Udbetalingsoplysninger genereres hver dag ved midnat, UTC-tid.", ue = "Udbetalinger", ce = "Afventer", ge = "Kom tilbage senere.", pe = "Kontakt support for at få hjælp.", fe = "Ræk ud efter støtte", ke = "Reference-id", me = "Opdater", be = "Refunderinger", ye = "Refunder betaling", ve = "Vi kunne ikke behandle refunderingen. Prøv igen senere.", he = "Noget gik galt.", Te = "Din kunde vil modtage pengene i løbet af højst 40 dage. Når refunderingen er gennemført, vil du se en ny refunderingstransaktion på din liste.", Re = "Refunderingen er sendt!", Ae = "Beløb til refundering", Pe = "Refunderinger kan tage op til 40 dage afhængigt af betalingsmetoden. Gebyrer er inkluderet.", De = "Refunder %{amount}", Fe = "Årsag til refundering", Se = "Reference", Ce = "Resterende beløb", Ne = "Rapport", Oe = "Rapporter genereres hver dag ved midnat, UTC-tid.", Ie = "Rapporter", Be = "Nulstil", we = "Tilbageført", Ve = "Noget gik galt.", xe = "Noget gik galt. Prøv at opdatere siden, eller kom tilbage senere.", Le = "Status", We = "Struktureret liste", je = "Subtraktioner", Ke = "Summen af udbetalinger samme dag", Me = "Faner", Ue = "Fejlkoden er %{requestId}", qe = "Der er ingen resultater", Ee = "Anmodningen mangler påkrævede felter eller indeholder ugyldige data.", Ge = "Der opstod en uventet fejl", He = "Den valgte saldokonto er forkert", Ye = "Tidszone", _e = "Til", ze = "Indgående i alt", Xe = "Udgående i alt", Je = 'Værdien "til" skal være lig med eller større end værdien "fra"', Qe = "Transaktionsoplysninger", Ze = "Transaktioner", $e = "Oversigt over transaktioner", en = "Transaktionstype", nn = "Overførsler", tn = "Prøv en anden søgning, eller nulstil dine filtre, så vi kan prøve igen.", an = "Prøv at opdatere siden, eller kom tilbage senere.", rn = "Beløb", on = "Type", ln = "Værdi", dn = "Vi kunne ikke indlæse oversigten over udbetalinger.", sn = "Vi kunne ikke indlæse oversigten over rapporter.", un = "Vi kunne ikke indlæse transaktionsoversigten.", cn = "Vi kunne ikke indlæse dine saldokonti.", gn = "Vi kunne ikke indlæse dine udbetalinger.", pn = "Vi kunne ikke indlæse dine rapporter.", fn = "Vi kunne ikke indlæse dine transaktioner.", kn = {
  account: e,
  accountBalance: n,
  accountDescription: t,
  accountID: a,
  additions: r,
  adjustments: i,
  amount: o,
  and: l,
  apply: d,
  back: s,
  balanceAccount: u,
  balanceAccountId: c,
  Booked: g,
  "button.clearAll": "Ryd alt",
  "calendar.controls": "Kontrolelementer til kalendernavigation",
  "calendar.nextMonth": "Næste måned",
  "calendar.previousMonth": "Forrige måned",
  "calendar.timezone": "Tidszone er indstillet til: GMT%{offset} (%{time})",
  "capital.accountIsInactive": "Din konto er inaktiv",
  "capital.actionNeeded": "Handling er påkrævet",
  "capital.bankAccountDetails": "Bankkontooplysninger",
  "capital.bankAccountIban": "IBAN",
  "capital.bankAccountNumber": "Kontonummer",
  "capital.bankCountryOrRegion": "Land-/område",
  "capital.bankRoutingNumber": "Routingnummer",
  "capital.bankSortCode": "Registreringsnummer",
  "capital.businessFinancing": "Virksomhedsfinansiering",
  "capital.businessFinancingOffer": "Tilbud om virksomhedsfinansiering",
  "capital.businessFinancingSummary": "Oversigt over virksomhedsfinansiering",
  "capital.closed": "Lukket",
  "capital.couldNotContinueWithTheOffer": "Vi kunne ikke fortsætte med tilbuddet.",
  "capital.couldNotLoadFinancialOffers": "Vi kunne ikke indlæse økonomiske tilbud.",
  "capital.dailyRepaymentRate": "Daglig tilbagebetalingssats",
  "capital.daysAndDaysLeft": "%{days} dage (%{daysLeft} dage tilbage)",
  "capital.expectedRepaymentPeriod": "Forventet tilbagebetalingsperiode",
  "capital.failed": "Fejlede",
  "capital.fees": "Gebyrer",
  "capital.fullyRepaid": "Fuldt tilbagebetalt",
  "capital.goToTermsAndConditions": "Gå til Vilkår og betingelser",
  "capital.grantID": "Bevillings-id",
  "capital.howMuchMoneyDoYouNeed": "Hvor mange penge har du brug for?",
  "capital.inProgress": "Igangværende",
  "capital.legalSubtitleAU": "Adyen Capital tilbydes af Adyen Australia Pty Limited.",
  "capital.legalSubtitleEU": "Lån udstedes af Adyen N.V.",
  "capital.legalSubtitleGB": "Lån udstedes af Adyen N.V. repræsenteret ved sin London-filial.",
  "capital.legalSubtitleUS": "Lån udstedes af Adyen N.V.'s filial i San Francisco og er underlagt kreditgodkendelse.",
  "capital.maximumRepaymentPeriod": "Maksimal tilbagebetalingsperiode",
  "capital.minimumRepaymentToRepayTheFinancingOnTime": "Minimumstilbagebetaling hver %{days}. dag for at tilbagebetale finansieringen til tiden",
  "capital.needSomeExtraMoney": "Brug for ekstra penge?",
  "capital.offerLegalNoticeDescriptionUS": "Hvis din ansøgning om erhvervskredit afvises, har du ret til en skriftlig redegørelse for de specifikke årsager til afvisningen. For at modtage erklæringen skal du kontakte Adyens Credit Support Team ved at sende en e-mail til %{email} inden for 60 dage fra den dato, hvor du blev informeret om vores beslutning. Vi sender dig en skriftlig redegørelse for afslaget inden for 30 dage efter, at vi har modtaget din anmodning om redegørelsen. %{break} Federal Equal Credit Opportunity Act forbyder kreditorer at diskriminere kreditansøgere på grundlag af race, farve, religion, national oprindelse, køn, civilstand, alder (forudsat at ansøgeren har juridisk kapacitet til at indgå en bindende kontrakt), fordi hele eller en del af ansøgerens indkomst stammer fra ethvert offentligt bistandsprogram, eller fordi ansøgeren i god tro har udøvet enhver ret i henhold til loven om forbrugerkreditbeskyttelse. Det føderale agentur, der håndhæver overholdelsen af denne lov i forhold til denne kreditor, er Office of the Comptroller of the Currency (OCC), 400 7th Street, SW Washington, DC 20219.",
  "capital.offerLegalNoticeTitleUS": "Kreditor: Adyen N.V. – San Francisco-filial %{break} 505 Brannan Street, San Francisco, CA 94107.",
  "capital.oneMonth": "1 måned",
  "capital.pending": "Afventer",
  "capital.primaryAccount": "Primær konto",
  "capital.remaining": "Resterende",
  "capital.remainingAmount": "Resterende beløb",
  "capital.remainingFees": "Resterende gebyrer",
  "capital.repaid": "Tilbagebetalt",
  "capital.repaidAmount": "Tilbagebetalt beløb",
  "capital.repaidFees": "Tilbagebetalte gebyrer",
  "capital.repaymentBalanceInfo": "Dit nuværende resterende beløb, inkl. gebyrer, er %{amount}",
  "capital.repaymentThreshold": "Tilbagebetalingsgrænse",
  "capital.requestedFunds": "Anmodede midler",
  "capital.requestFunds": "Anmod om midler",
  "capital.requesting": "Anmodning",
  "capital.reviewOffer": "Gennemgå tilbud",
  "capital.revoked": "Tilbagekaldt",
  "capital.seeNewOffer": "Se nyt tilbud",
  "capital.seeOptions": "Se muligheder",
  "capital.sendRepayment": "Send tilbagebetaling",
  "capital.sendRepaymentNotice": "Den ekstra bankoverførsel, du har foretaget til din lånerebetaling, kan tage 2-3 hverdage, før den vises på din lånekonto.",
  "capital.sendRepaymentSubtitle": "Overfør penge til denne bankkonto for at betale en del af dit lån eller hele beløbet.",
  "capital.signTermsAndConditionsToReceiveFunds": "Underskriv Vilkår og betingelser for at modtage dine midler.",
  "capital.signTheTermsToReceiveYourFunds": "Underskriv vilkårene for at modtage dine midler",
  "capital.termEnds": "Perioden slutter: ",
  "capital.thereIsNoPrimaryAccountConfigured": "Der er ingen primær konto konfigureret",
  "capital.thisOfferExpiresOn": "Dette tilbud udløber den %{date}.",
  "capital.totalFees": "Totaler gebyrer",
  "capital.totalRepaymentAmount": "Samlet tilbagebetalingsbeløb",
  "capital.unsupportedRegionDescription": "Virksomhedsfinansiering er endnu ikke tilgængelig i din region, men vi arbejder på at kunne tilbyde dig den bedste løsning snart.",
  "capital.unsupportedRegionTitle": "Hold dig opdateret!",
  "capital.weCouldNotContinueWithTheOffer": "Vi kunne ikke fortsætte med tilbuddet.",
  "capital.weCouldNotContinueWithTheOfferContactSupportForHelp": "Vi kunne ikke fortsætte med tilbuddet. Kontakt support for at få hjælp.",
  "capital.weCouldNotLoadFinancialOffers": "Vi kunne ikke indlæse økonomiske tilbud.",
  "capital.weCouldNotProcessThisRequestTryAgain": "Vi kunne ikke behandle denne anmodning. Prøv igen med et nyt tilbud.",
  "capital.weReceivedYourRequestAndWeAreWorkingOnItNowCheckBackSoon": "Vi har modtaget din anmodning, og vi arbejder på den. Kom snart tilbage for at se næste skridt.",
  "capital.writtenOff": "Afskrevet",
  "capital.xDays": "%{days} dage",
  "capital.xMonths": "%{months} måneder",
  "capital.xPercent": "%{percentage} %",
  "capital.youAcceptedButThenReturnedTheseFunds": "Du accepterede, men returnerede derefter disse midler",
  "capital.youAcceptedTheseFundsButDidNotRepayThem": "Du accepterede disse midler, men tilbagebetalte dem ikke",
  "capital.youAreRequestingFundingOf": "Du anmoder om finansiering af",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part1": "Du er blevet prækvalificeret til virksomhedsfinansiering",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part2": " Op til %{amount}.",
  "capital.yourRequestedFundsWere": "Dine anmodede midler var: ",
  "capital.youShouldGetTheFundsWithinOneBusinessDay": "Du bør modtage pengene inden for et arbejdsdag",
  "capital.youWillNeedToRepayAMinimumOfXEveryXDaysToPayOffTheFunds": "Du skal tilbagebetale mindst %{amount} hver %{days}. dag for at betale alle pengene tilbage inden %{date}.",
  "capital.youWillSoonQualifyForAFinancialOffer": "Du kvalificerer dig snart til et økonomisk tilbud!",
  capture: p,
  category: f,
  chargeback: k,
  closeIconLabel: m,
  contactSupport: b,
  contactSupportForHelp: y,
  contactSupportForHelpAndShareErrorCode: v,
  copied: h,
  copy: T,
  correction: R,
  currency: A,
  date: P,
  dateRange: D,
  default: "Standard",
  description: F,
  dismiss: S,
  download: C,
  downloading: N,
  email: O,
  entityWasNotFound: I,
  entityWasNotFoundDetail: B,
  "error.pleaseTryAgainLater": "Prøv igen senere.",
  "error.somethingWentWrongWithDownload": "Noget gik galt under download",
  "expandableCard.collapse": "Skjul",
  "expandableCard.expand": "Udvid",
  export: "Eksporter",
  fee: w,
  file: V,
  "filter.date.since": "Siden %{date}",
  "filter.date.until": "Indtil %{date}",
  filterBar: x,
  "filterPlaceholder.category": "Type",
  "filterPlaceholder.currency": "Valuta",
  "filterPlaceholder.status": "Status",
  from: L,
  full: W,
  fundsCaptured: j,
  goBack: K,
  grantIssued: M,
  grantRepayment: U,
  hideContent: q,
  id: E,
  incompleteField: G,
  inProgress: H,
  loading: Y,
  max: _,
  min: z,
  mobile: X,
  netPayout: J,
  nextPayouts: Q,
  noData: Z,
  noNegativeNumbersAllowed: $,
  noPayoutsFound: ee,
  noReportsFound: ne,
  noTransactionsFound: te,
  other: ae,
  paginatedNavigation: re,
  "pagination.nextPage": "Næste side",
  "pagination.previousPage": "Forrige side",
  "pagination.showing": "Viser",
  partial: ie,
  paymentId: oe,
  paymentMethod: le,
  payoutDetails: de,
  payoutsNotice: se,
  payoutsTitle: ue,
  Pending: ce,
  pleaseComeBackLater: ge,
  pleaseReachOutToSupportForAssistance: pe,
  "rangePreset.custom": "Tilpas",
  "rangePreset.last30Days": "Sidste 30 dage",
  "rangePreset.last7Days": "Sidste 7 dage",
  "rangePreset.lastMonth": "Sidste måned",
  "rangePreset.lastWeek": "Sidste uge",
  "rangePreset.thisMonth": "Denne måned",
  "rangePreset.thisWeek": "Denne uge",
  "rangePreset.yearToDate": "År til dato",
  reachOutToSupport: fe,
  referenceID: ke,
  refresh: me,
  refund: be,
  "refund.amountAlreadyRefunded": "Du har allerede refunderet %{amount}",
  "refund.amountFailed": "Refunderingen af %{amount} mislykkedes. Det er i øjeblikket ikke muligt at refundere dette beløb. Kontakt support.",
  "refund.amountInProgress": "Den delvise refundering af %{amount} behandles.",
  "refund.fee": "Gebyr",
  "refund.fullAmountFailed": "Det er ikke muligt at refundere denne betaling. Kontakt support.",
  "refund.fullAmountRefunded": "Det fulde beløb er refunderet til kunden",
  "refund.goToPayment": "Gå til betaling",
  "refund.maximumRefundable": "Du kan højst refundere %{amount}",
  "refund.onlyRefundable": "Du kan kun refundere %{amount}",
  "refund.originalAmount": "Oprindeligt beløb",
  "refund.originalPayment": "Oprindelig betaling",
  "refund.paymentPspReference": "PSP-betalingsreference",
  "refund.pspReference": "PSP-reference",
  "refund.refundFee": "Gebyr for refundering",
  "refund.refundPspReference": "Refundering PSP-reference",
  "refund.returnToRefund": "Tilbage til refundering",
  "refund.theRefundIsBeingProcessed": "Refunderingen er ved at blive behandlet.",
  refundAction: ye,
  refundActionErrorSubtitle: ve,
  refundActionErrorTitle: he,
  refundActionSuccessSubtitle: Te,
  refundActionSuccessTitle: Re,
  refundAmount: Ae,
  "refundAmount.excess": "Du kan ikke overskride det tilgængelige beløb på %{amount}",
  "refundAmount.required": "Indtast et beløb til refundering",
  "refunded.full": "Fuldt refunderet",
  "refunded.partial": "Delvist refunderet",
  refundNotice: Pe,
  refundPayment: De,
  refundReason: Fe,
  "refundReason.duplicate": "Duplikat",
  "refundReason.fraudulent": "Svindlerisk",
  "refundReason.issue_with_item_sold": "Problem med solgt vare",
  "refundReason.other": "Andet",
  "refundReason.requested_by_customer": "Anmodet af kunden",
  refundReference: Se,
  "refundReference.placeholder": "Indtast referencen her",
  remainingAmount: Ce,
  report: Ne,
  "reportsError.tooManyDownloads": "Vi kunne ikke downloade alle filerne. Prøv igen senere.",
  reportsNotice: Oe,
  reportsTitle: Ie,
  "reportType.payout": "Udbetaling",
  reset: Be,
  Reversed: we,
  "select.filter.placeholder": "Pladsholder",
  "select.noOptionsFound": "Ingen muligheder stemmer ikke overens med denne søgning",
  somethingWentWrong: Ve,
  somethingWentWrongTryRefreshingOrComeBackLater: xe,
  status: Le,
  structuredList: We,
  subtractions: je,
  sumOfSameDayPayouts: Ke,
  tabs: Me,
  theErrorCodeIs: Ue,
  thereAreNoResults: qe,
  theRequestIsMissingRequiredFieldsOrContainsInvalidData: Ee,
  thereWasAnUnexpectedError: Ge,
  theSelectedBalanceAccountIsIncorrect: He,
  timezone: Ye,
  to: _e,
  "tooltip.ATM": "Penge hævet i en pengeautomat",
  "tooltip.Capital": "Penge fra et indgående lånetilskud eller udgående tilbagebetaling af lån",
  "tooltip.Chargeback": "Penge tilbage til en kunde efter en bestridt transaktion",
  "tooltip.Correction": "Justeringer af dine midler, herunder tilbageførsler af transaktioner og korrektioner af indbetalinger",
  "tooltip.Fee": "Transaktionsomkostninger og gebyrer for betalingsmetoder",
  "tooltip.Other": "Transaktioner, der ikke er i en anden kategori, normalt en justering",
  "tooltip.Payment": "Penge modtaget på din konto fra en salgstransaktion",
  "tooltip.Refund": "Penge sendt tilbage til en kunde fra en refunderet transaktion",
  "tooltip.totalIncoming": "Alle penge modtaget på din konto baseret på de valgte filtre",
  "tooltip.totalOutgoing": "Alle gebyrer, tilbagebetalinger, udbetalinger og andre afgifter baseret på de valgte filtre",
  "tooltip.Transfer": "Penge flyttet mellem din konto og en anden konto",
  totalIncoming: ze,
  totalOutgoing: Xe,
  toValueShouldBeGreaterThanTheFromValue: Je,
  transactionDetails: Qe,
  transactions: Ze,
  transactionsOverviewTitle: $e,
  transactionType: en,
  transfer: nn,
  tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain: tn,
  tryRefreshingThePageOrComeBackLater: an,
  txAmount: rn,
  "txType.ATM": "Pengeautomat",
  "txType.Capital": "Kapital",
  "txType.Chargeback": "Chargeback",
  "txType.Correction": "Rettelse",
  "txType.Fee": "Gebyr",
  "txType.Other": "Andet",
  "txType.Payment": "Betaling",
  "txType.Refund": "Refunderinger",
  "txType.Transfer": "Overfør",
  type: on,
  value: ln,
  weCouldNotLoadThePayoutsOverview: dn,
  weCouldNotLoadTheReportsOverview: sn,
  weCouldNotLoadTheTransactionsOverview: un,
  weCouldNotLoadYourBalanceAccounts: cn,
  weCouldNotLoadYourPayouts: gn,
  weCouldNotLoadYourReports: pn,
  weCouldNotLoadYourTransactions: fn
};
export {
  g as Booked,
  ce as Pending,
  we as Reversed,
  e as account,
  n as accountBalance,
  t as accountDescription,
  a as accountID,
  r as additions,
  i as adjustments,
  o as amount,
  l as and,
  d as apply,
  s as back,
  u as balanceAccount,
  c as balanceAccountId,
  p as capture,
  f as category,
  k as chargeback,
  m as closeIconLabel,
  b as contactSupport,
  y as contactSupportForHelp,
  v as contactSupportForHelpAndShareErrorCode,
  h as copied,
  T as copy,
  R as correction,
  A as currency,
  P as date,
  D as dateRange,
  kn as default,
  F as description,
  S as dismiss,
  C as download,
  N as downloading,
  O as email,
  I as entityWasNotFound,
  B as entityWasNotFoundDetail,
  w as fee,
  V as file,
  x as filterBar,
  L as from,
  W as full,
  j as fundsCaptured,
  K as goBack,
  M as grantIssued,
  U as grantRepayment,
  q as hideContent,
  E as id,
  H as inProgress,
  G as incompleteField,
  Y as loading,
  _ as max,
  z as min,
  X as mobile,
  J as netPayout,
  Q as nextPayouts,
  Z as noData,
  $ as noNegativeNumbersAllowed,
  ee as noPayoutsFound,
  ne as noReportsFound,
  te as noTransactionsFound,
  ae as other,
  re as paginatedNavigation,
  ie as partial,
  oe as paymentId,
  le as paymentMethod,
  de as payoutDetails,
  se as payoutsNotice,
  ue as payoutsTitle,
  ge as pleaseComeBackLater,
  pe as pleaseReachOutToSupportForAssistance,
  fe as reachOutToSupport,
  ke as referenceID,
  me as refresh,
  be as refund,
  ye as refundAction,
  ve as refundActionErrorSubtitle,
  he as refundActionErrorTitle,
  Te as refundActionSuccessSubtitle,
  Re as refundActionSuccessTitle,
  Ae as refundAmount,
  Pe as refundNotice,
  De as refundPayment,
  Fe as refundReason,
  Se as refundReference,
  Ce as remainingAmount,
  Ne as report,
  Oe as reportsNotice,
  Ie as reportsTitle,
  Be as reset,
  Ve as somethingWentWrong,
  xe as somethingWentWrongTryRefreshingOrComeBackLater,
  Le as status,
  We as structuredList,
  je as subtractions,
  Ke as sumOfSameDayPayouts,
  Me as tabs,
  Ue as theErrorCodeIs,
  Ee as theRequestIsMissingRequiredFieldsOrContainsInvalidData,
  He as theSelectedBalanceAccountIsIncorrect,
  qe as thereAreNoResults,
  Ge as thereWasAnUnexpectedError,
  Ye as timezone,
  _e as to,
  Je as toValueShouldBeGreaterThanTheFromValue,
  ze as totalIncoming,
  Xe as totalOutgoing,
  Qe as transactionDetails,
  en as transactionType,
  Ze as transactions,
  $e as transactionsOverviewTitle,
  nn as transfer,
  tn as tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain,
  an as tryRefreshingThePageOrComeBackLater,
  rn as txAmount,
  on as type,
  ln as value,
  dn as weCouldNotLoadThePayoutsOverview,
  sn as weCouldNotLoadTheReportsOverview,
  un as weCouldNotLoadTheTransactionsOverview,
  cn as weCouldNotLoadYourBalanceAccounts,
  gn as weCouldNotLoadYourPayouts,
  pn as weCouldNotLoadYourReports,
  fn as weCouldNotLoadYourTransactions
};
